import { render } from "./iconMap.vue?vue&type=template&id=cb046a4c&scoped=true"
import script from "./iconMap.vue?vue&type=script&lang=js"
export * from "./iconMap.vue?vue&type=script&lang=js"

import "./iconMap.vue?vue&type=style&index=0&id=cb046a4c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cb046a4c"

export default script